import '@gladysassistant/theme-optimized/dashboard.css';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import './style';
import App from './components/app';

export default App;
